const POINT_TYPE = {
  EARNED: {
    color: 'blue',
    label: '적립',
    value: 'EARNED',
  },
  REFUNDED: {
    color: 'magenta',
    label: '환불적립',
    value: 'REFUNDED',
  },
  EXPIRED: {
    color: 'red',
    label: '만료',
    value: 'EXPIRED',
  },
  USED: {
    color: 'orange',
    label: '사용',
    value: 'USED',
  },
  DEDUCTED: {
    color: 'purple',
    label: '차감',
    value: 'DEDUCTED',
  },
};

export { POINT_TYPE };
